type RootState = {
  general?: {
    usersFeaturedData?: any[];
  };
  register?: {
    usersBySkill?: any[];
    itemCount?: number;
    page?: number;
    skillsList?: any[];
  };
  profile?: {
    usersInJurisdiction?: any[];
  };
};

export const selectFeaturedUsers = (state: RootState) =>
  state.general?.usersFeaturedData ?? [];

export const selectSkillsList = (state: RootState) => state.register?.skillsList ?? [];

export const selectJurisdictions = (state: RootState) =>
  state.profile?.usersInJurisdiction ?? [];

export const selectFilteredUsers = (state: RootState) =>
  state.register?.usersBySkill ?? [];

export const selectFilteredMeta = (() => {
  let lastItemCount = 0;
  let lastPage = 1;
  let lastResult = { itemCount: 0, page: 1 };

  return (state: RootState) => {
    const registerState: any = state.register ?? {};
    const itemCount = registerState?.itemCount ?? 0;
    const page = registerState?.page ?? 1;

    if (itemCount !== lastItemCount || page !== lastPage) {
      lastItemCount = itemCount;
      lastPage = page;
      lastResult = { itemCount, page };
    }

    return lastResult;
  };
})();
